"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.WidgetSchema = void 0;
var zod_1 = require("zod");
var widgets_1 = require("./widgets");
var MypageWidgetDataSchema = zod_1.z.union([
    widgets_1.MyPageBenefitBannerWidgetDataSchema,
    widgets_1.MyPageMenuWidgetDataSchema,
    widgets_1.MyPageUserInfoWidgetDataSchema,
    widgets_1.MypageUpcomingReservationWidgetDataSchema,
    widgets_1.MypageTripPlanWidgetDataSchema,
]);
var ConvertedMypageWidgetDataSchema = zod_1.z.union([
    widgets_1.ConvertedMypageBenefitBannerWidgetDataSchema,
    widgets_1.ConvertedMyPageMenuWidgetDataSchema,
    widgets_1.MyPageUserInfoWidgetDataSchema,
    widgets_1.MypageUpcomingReservationWidgetDataSchema,
    widgets_1.ConvertedMypageTripPlanWidgetDataSchema,
]);
var WIDGET_TYPES = [
    'YDM__NOL_MY_CUSTOMER_SERVICE__V1',
    'YDM__NOL_MY_ETC__V1',
    'YDM__NOL_MY_EVENT__V1',
    'YDM__NOL_MY_RESERVATION_LIST__V1',
    'YDM__NOL_MY_SERVICE_MANAGEMENT__V1',
    'YDM__NOL_MY_USER_INFORMATION__V1',
    'YDM__NOL_MY_UPCOMING_RESERVATION__V1',
    'YDM__NOL_MY_TRIP_PLAN__V1',
];
exports.WidgetSchema = zod_1.z.enum(WIDGET_TYPES);
var MypageWidgetDataStatusSchema = zod_1.z.enum(['SUCCESS', 'FAIL']);
var MypageWidgetSchema = zod_1.z.object({
    /** 위젯 데이터 */
    data: MypageWidgetDataSchema,
    /** 응답 실패시 재시도 관련 설정 */
    retry: zod_1.z
        .object({
        /** 재시도 호출 API 정보 */
        api: zod_1.z
            .object({
            method: zod_1.z.string(),
            timeout: zod_1.z.number(),
            url: zod_1.z.string(),
        })
            .optional(),
        /** 재시도 노출 문구*/
        title: zod_1.z.string(),
    })
        .nullable(),
    /** 응답 성공 여부 */
    status: MypageWidgetDataStatusSchema,
    /** 위젯 타겟 - 노출 지면 */
    target: zod_1.z.string(),
    /** YDM에서 설정한 위젯의 타입명 */
    type: zod_1.z.string(),
});
var MypageMemberInterestsSchema = zod_1.z.object({
    /** 회원정보 추가 수집을 위한 화면 노출 여부 */
    isEnabled: zod_1.z.boolean(),
    /** 회원정보 추가 수집을 위한 정보 입력 web-view 페이지 url */
    action: zod_1.z.object({ app: zod_1.z.string(), web: zod_1.z.string() }),
});
var MypageAdditionalInfoSchema = zod_1.z.object({
    memberInterests: MypageMemberInterestsSchema.nullable(),
});
var MypageResponseSchema = zod_1.z.object({
    additionalInfo: MypageAdditionalInfoSchema,
    isLogin: zod_1.z.boolean(),
    widgets: zod_1.z.array(MypageWidgetSchema),
});
var ConvertedMypageWidgeDatatRetrySchema = zod_1.z.object({
    /** 재시도 노출 문구*/
    title: zod_1.z.string(),
});
var ConvertedMypageWidgetSchema = zod_1.z.object({
    /** 위젯 데이터 */
    data: ConvertedMypageWidgetDataSchema,
    /** 응답 성공 여부 */
    status: MypageWidgetDataStatusSchema,
    /** 위젯 타겟 - 노출 지면 */
    target: zod_1.z.string(),
    /** YDM에서 설정한 위젯의 타입명 */
    type: exports.WidgetSchema,
    /** 재시도 호출 API 정보 */
    retry: ConvertedMypageWidgeDatatRetrySchema.optional(),
});
var ConvertedNavigationBarSchema = zod_1.z.object({
    cart: zod_1.z.number(),
    push: zod_1.z.number(),
});
var ConvertedMypageResponseSchema = zod_1.z.object({
    additionalInfo: MypageAdditionalInfoSchema.nullable(),
    isLogin: zod_1.z.boolean(),
    widgets: zod_1.z.array(ConvertedMypageWidgetSchema),
    navigationBar: ConvertedNavigationBarSchema,
    errorStatusCode: zod_1.z.number().optional(),
});
